/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Card, Checkbox, Col, DatePicker, Form, Row, message, Button } from 'antd';
import moment from 'moment';
import SPUploadSinglePhoto from 'components/base/SPUploadSinglePhoto';
import VideoPreview from '../VideoPreview';
import { getVideoFrameImage } from 'utils/tool';
import { useOrderList } from 'hooks/order-management/order-list';
import { API_VEHICLE_UPLOAD_PHOTO, API_UPLOAD_PR_CAR_VIDEO } from 'hooks/carRental/_';
import SPUploadPhotos from 'components/base/SPUploadPhotos';
import CarSeriesInfo from '../components/CarSeriesInfo';
import SPUpload from 'components/base/SPUpload';

interface PropsType {
	enums?: any;
	data?: any;
	permission?: any;
}

const ReturnInfo: React.FC<PropsType> = props => {
	const { data, enums } = props;
	const [form] = Form.useForm();
	const [thumbSrc, setThumbSrc] = useState<string>('');
	const { order_status } = props?.data?.order_info || {};
	const [isOuterDamage, setIsOuterDamage]  = useState<boolean>(false);

	const [isInteriorDamage, setIsInteriorDamage]  = useState<boolean>(false);

	const { returnCar } = useOrderList();

	const handleOuterDamage = (e: any) => {
		setIsOuterDamage(e?.target?.checked);
	}

	const handleInteriorDamage = (e: any) => {
		setIsInteriorDamage(e?.target?.checked);
	}

	const handleSubmit = () => {
		form.validateFields().then(() => {
		  const data = form.getFieldsValue();
		  const formData = Object.keys(data).reduce((prev: any, next: any) => {
        if (['outer_damage', 'interior_damage'].includes(next)) {
          prev[next] = data[next]?.map((item: any) => ({
          ...item, image: item.image?.file_addr
          }))
        } else if (next === 'contract_image') {
          prev[next] = data[next]?.map((item: any) => item.file_addr).join(',');
        } else {
          prev[next] = data[next]?.file_addr;
        }
        return prev;
		  }, {});
	
			const {
				odometer_image,
				veh_inspection_video,
				outer_damage,
				interior_damage,
			} = formData;

			const params: any = {
				odometer_image,
				veh_inspection_video,
			}

      if (isOuterDamage) {
        params.outer_damage = (outer_damage || []).map((item: any) => ({ position: 1, type: 1, image: item.file_addr }));
      }

      if (isInteriorDamage) {
        params.interior_damage = (interior_damage || [])?.map((item: any) => ({ position: 1, type: 1, image: item.file_addr }));
      }

			returnCar(params, props?.data?.order_info || {}).then((res: any) => {
				message.success('还车成功');
			});
		}).catch(() => {
		  console.log('表单失败了');
		});
	  }

	useEffect(() => {
		if (data.return_material_info) {
			const info = data?.return_material_info;
			const { return_time } = data?.order_info || {};
			const { interior_damage, outer_damage } = info || {};
      
      const outer_damage_checked =  (outer_damage || []).length > 0;
      const interior_damage_checked = (interior_damage || []).length > 0;
      setIsInteriorDamage(interior_damage_checked);
      setIsOuterDamage(outer_damage_checked);
			const params = {
				odometer_image: info?.veh_info?.odometer_image,
				veh_inspection: info?.veh_inspection,
				interior_damage: (interior_damage || []).map((item: any) => item.image),
				interior_damage_checked,
        		outer_damage: (outer_damage || []).map((item: any) => item.image),
				outer_damage_checked,
				return_time: return_time ? moment(return_time) : undefined,
				veh_inspection_video: info?.veh_info?.veh_inspection_video,
			};
			form.setFieldsValue(params);
			if (info?.veh_info?.veh_inspection_video) {
				getVideoFrameImage(info?.veh_info?.veh_inspection_video).then((res: any) => {
					setThumbSrc(res);
				});
			}
		}
	}, [data]);

	const disabled = order_status !== 2;

	return (
		<>
			<Card title="" style={{ marginBottom: 20 }}>
				<div style={{ display: 'flex', marginBottom: 12 }}>
					<span style={{ fontWeight: 'bold', marginRight: 12 }}>车辆信息:</span>
					<CarSeriesInfo style={{ color: 'rgb(255, 100, 0)' }} orderInfo={props?.data?.order_info} enums={enums} />
				</div>
			</Card>
			<Form form={form} labelCol={{ span: 4 }} disabled={disabled} scrollToFirstError>
			<Card title="车辆信息">
				{disabled && <Row gutter={24}>
					<Col span={12}>
						<Form.Item
							name="return_time"
							label="实际还车时间"
              labelCol={{ span: 5 }}
							rules={[{ required: true, message: '请选择实际还车时间' }]}
						>
							<DatePicker showTime format="YYYY-MM-DD HH:mm" />
						</Form.Item>
					</Col>
				</Row>}
				<Row gutter={24}>
					<Col span={12}>
						<Form.Item
							name="odometer_image"
							label="里程/油表："
							rules={[{ required: true, message: '请上传里程/油表' }]}
						>
							<SPUploadSinglePhoto accept='.jpg,.jpeg,.png' hideTitle action={API_VEHICLE_UPLOAD_PHOTO} />
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item
							name="veh_inspection_video"
							label="验车视频："
							rules={[{ required: true, message: ' 请上传验车视频' }]}
						>
							{order_status === 2 ? <SPUpload accept='.mp4,.webm,.ogg,.mov' fileType="video" size={200} action={API_UPLOAD_PR_CAR_VIDEO} /> : <VideoPreview thumbSrc={thumbSrc} />}
						</Form.Item>
					</Col>
				</Row>
			</Card>
			<Card title="车辆外观" style={{ marginTop: '20px' }}>
				<Form.Item label="是否有车辆损伤" name="outer_damage_checked" valuePropName="checked">
					<Checkbox onChange={handleOuterDamage} />
				</Form.Item>
        		{isOuterDamage && <Form.Item
					label="车损照片"
					name="outer_damage"
					rules={[{ required: true, message: '请上传车辆损伤部位照片' }]}
				>
          <SPUploadPhotos hideTitle action={API_VEHICLE_UPLOAD_PHOTO} />
			</Form.Item>}
				</Card>
				<Card title="车辆内饰" style={{ marginTop: '20px' }}>
					<Form.Item label="是否有车辆损伤" name="interior_damage_checked" valuePropName="checked">
						<Checkbox onChange={handleInteriorDamage} />
					</Form.Item>
					{isInteriorDamage && <Form.Item
						label="车损照片"
						name="interior_damage"
						rules={[{ required: true, message: '请上传车辆损伤部位照片' }]}
					>
			<SPUploadPhotos hideTitle action={API_VEHICLE_UPLOAD_PHOTO} />
			</Form.Item>}
			</Card>
			{!disabled && <Button type='primary' style={{ marginTop: 20 }} disabled={disabled} onClick={handleSubmit}>确定还车</Button>}
		</Form>
		</>
		
	);
};

export default ReturnInfo;
